// extracted by mini-css-extract-plugin
module.exports = {"socialmenu":"SocialMenu_socialmenu__ZpCgz","wrapper":"SocialMenu_wrapper__3uJzk"};